<template>
  <button
    v-on:click="onClick"
    :class="{ 
    	'text-white py-4 text-xs uppercase font-semibold focus:outline-none' : true,
    	'bg-blue-500 hover:bg-blue-600' : color == 'blue', 
    	'bg-red-500 hover:bg-red-dark' : color == 'red',
    	'bg-green-500 hover:bg-green-600' : color == 'green',
    	'w-full' : isFullWidth,
    	'w-48' : !isFullWidth,
    }">
    <template v-if="loading"><img src="/static/img/ajax-loader.gif" class="inline" /></template>
    <template v-else>{{ label }}</template>
  </button>
</template>

<script>
	export default {
		props : {
			onClick : {
				type    : Function,
				required: false
			},

			loading : {
				type    : Boolean,
				required: false
			},

			label : {
				type    : String,
				required: false,
				default : "Save"
			},

			color : {
				type    : String,
				required: false,
				default : "blue"
			},

			isFullWidth : {
				type    : Boolean,
				required: false,
				default : false
			},
		}
	}
</script>